import { Timestamp } from './firebase';

export interface NavBarProps {
  isOpen: boolean;
  onClick: () => void;
}

export interface AppError {
  code: string;
  message: string;
}

export type FetchResponse<T> =
  | { type: 'success'; data: T }
  | { type: 'error'; error: AppError };

// Alerts.
export type AlertType = 'error' | 'success' | 'info' | 'warning' | undefined;

export enum Alert {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
}

// Admins.
export interface Admin {
  id: string;
}

// Message.
export interface Message {
  id: string;
  date: Timestamp;
  imageURL: string;
  text: string;
}

export interface MessageInput {
  id?: string;
  date: Date;
  imageURL: string | Blob;
  text: string;
}

// Media.
export interface MediaFile {
  name: string;
  file: string | File;
}

export interface AudioOption {
  audioTrack: string;
  padsTrack: string;
  duration: number;
}

export interface AudioOptionInput {
  audioTrack: MediaFile;
  padsTrack: MediaFile;
  duration: number | null;
}

export interface OptionAudios {
  audioTrack: string | null;
  padsTrack: string | null;
}

// Program.
export interface Program {
  id?: string;
  name: string;
  description: string;
  imageURL: string;
  videoURL: string;
  isSubscriptionRequired: boolean;
  enabled: boolean;
  options: AudioOption[];
  order: number;
}

export interface ProgramInput {
  name: string;
  description: string;
  order: number;
  enabled: boolean;
  isSubscriptionRequired: boolean;
  options: AudioOptionInput[];
  video: MediaFile;
  imageURL: string | Blob;
}

// Image.
export interface ImageArea {
  width: number;
  height: number;
  x: number;
  y: number;
}

export interface ImageCrop {
  x: number;
  y: number;
}

export interface ImageCropResult {
  url: string;
  file: Blob;
}

// Local Storage.
export enum StorageKey {
  MessagesTableRPP = 'MessagesTableRPP',
  MessagesTablePage = 'MessagesTablePage',
  ProgramsTableRequiredRPP = 'ProgramsTableRequiredRPP',
  ProgramsTableRequiredPage = 'ProgramsTableRequiredPage',
  ProgramsTableNoRequiredRPP = 'ProgramsTableNoRequiredRPP',
  ProgramsTableNoRequiredPage = 'ProgramsTableNoRequiredPage',
}

export interface NavigationBack {
  goBack: boolean;
}
